// import cards from '~/assets/icons/cards.svg';
import { useState } from 'react';
import { useEffectOnce } from 'react-use';
import cash from '~/assets/icons/cash.svg';
import compass from '~/assets/icons/compass.svg';
import deposit from '~/assets/icons/deposit.svg';
import home from '~/assets/icons/home.svg';
import transfer from '~/assets/icons/transfer.svg';
import { rage } from '~/rage';
import {
	setMaxIndex,
	setSelectedIndex,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { MenuItem } from '../MenuItem';
import { StyledContainer } from './MenuItems.styled';

const MenuItems: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const [hasHouses, setHasHouses] = useState<boolean>(false);

	const selectedIndex = useLayoutSelector(
		(state) => state.menuSelection.selectedIndex,
	);

	useEffectOnce(() => {
		rage.houses
			.getOwnedHousesIds()
			.then((ids) => {
				const has = ids.length > 0;
				setHasHouses(has);
				dispatch(setMaxIndex(has ? 4 : 3));
			})
			.catch((err) => rage.notifications.showException(err));
	});

	const items = [
		{ name: 'Главная', icon: compass },
		{ name: 'Пополнение счёта', icon: deposit },
		{ name: 'Снятие наличных', icon: cash },
		{ name: 'Перевод средств', icon: transfer },
	];

	if (hasHouses) {
		items.push({ name: 'Оплата налогов', icon: home });
	}

	return (
		<StyledContainer>
			{items.map((item, index) => (
				<MenuItem
					text={item.name}
					icon={item.icon}
					key={index}
					active={index === selectedIndex}
					onClick={() => {
						dispatch(setSelectedIndex(index));
					}}
				/>
			))}
		</StyledContainer>
	);
};

export { MenuItems };
